import React from "react";
import { mediaPosts } from "../constant/media";

const MediaComp = () => {
  const col1 = mediaPosts.filter((_, index) => index % 3 === 0);
  const col2 = mediaPosts.filter((_, index) => index % 3 === 1);
  const col3 = mediaPosts.filter((_, index) => index % 3 === 2);

  const renderColumn = (posts, extraColStyle = {}) => (
    <div className="col-md-4 mb-2" style={extraColStyle}>
      <div className="row m-0 p-0">
        {posts.map((post, index) => (
          <div
            key={post.id || index}
            className={`col-12 ${index > 0 ? "mt-4" : ""}`}
          >
            <div className="card" style={{ position: "relative" }}>
              <div className="card-body">
                <iframe
                  style={{ width: "100%" }}
                  src={post.embedUrl}
                  height={post.height || "700"}
                  width="504"
                  frameBorder="0"
                  allowFullScreen=""
                  title={post.title || `Embedded post ${post.id || index + 1}`}
                ></iframe>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <section className="media-bg p-0 bg-white" data-aos="fade-up">
        <div className="container">
          <div className="row">
            <div
              className="container"
              style={{
                marginTop: "5%",
                paddingLeft: "20%",
                paddingRight: "20%",
              }}
            >
              <div className="row text-center mt-4 mb-4">
                <div className="col">
                  <p className="sliderSubHeading">IN MEDIA</p>
                  <h1 className="mb-5">
                    Discover us
                    <br />
                    in action.
                  </h1>
                  <img
                    src="./images/Vector 6.png"
                    alt="Decorative Image"
                    className="staff-diff-bg-image"
                  />
                </div>
              </div>
            </div>

            {renderColumn(col1)}
            {renderColumn(col2, { marginTop: "30px", marginBottom: "-30px" })}
            {renderColumn(col3)}
          </div>
        </div>
      </section>

      <hr style={{ marginTop: "0rem", marginBottom: "0rem" }} />
    </>
  );
};

export default MediaComp;
